// axiosIntances.js
import axios from 'axios';
import { getKeycloak } from './keycloak.js';

let checkAvailability;
let clannAxios;
let savatarAxios;
let picksAxios;

let _kcRefreshTimer = null;


function startKeycloakAutoRefresh(kc, minValiditySec = 30) {
  stopKeycloakAutoRefresh();

  if (!kc || !kc.token) {return;}

  const schedule = () => {
    if (!kc?.tokenParsed?.exp) {
      _kcRefreshTimer = setTimeout(() => {
        schedule();
      }, 30 * 1000);
      return;
    }

    const expiresAtMs = kc.tokenParsed.exp * 1000;
    const refreshAtMs = expiresAtMs - (minValiditySec * 1000);
    const now = Date.now();
    const delay = Math.max(refreshAtMs - now, 0);

    _kcRefreshTimer = setTimeout(async () => {
      try {
        const _refreshed = await kc.updateToken(minValiditySec);
        schedule();
      } catch {
        console.error('Auto token refresh fallito');
        stopKeycloakAutoRefresh();
        kc.logout();
      }
    }, delay);
  };

  schedule();
}

function stopKeycloakAutoRefresh() {
  if (_kcRefreshTimer) {
    clearTimeout(_kcRefreshTimer);
    _kcRefreshTimer = null;
  }
}


async function initialize() {
  const environment = (await axios.get('/config/environment.json', { baseURL: '' })).data;

  checkAvailability = axios.create({
    baseURL: environment.holidayApi,
  });
  clannAxios = axios.create({
    baseURL: environment.apiUrl,
  });
  savatarAxios = axios.create({
    baseURL: environment.savatarApi,
  });
  picksAxios = axios.create({
    baseURL: environment.picksApi,
  });

  const instancesWithXAuth = [checkAvailability, clannAxios, savatarAxios];
  const instancesWithoutXAuth = [picksAxios];

  const setHeaders = (instance, includeXAuth = false) => {
    instance?.interceptors.request.use(async (request) => {
      const kc = getKeycloak();

      if (kc?.token) {
        try {
          await kc.updateToken(30);
          request.headers.Authorization = `Bearer ${kc.token}`;

          if (includeXAuth) {
            request.headers['X-Auth-Token'] = kc.token;
          }
        } catch {
          console.error('Token refresh failed in request interceptor');
          try {
            kc.logout();
          } catch { /* fallback ignore */ }
        }
      }
      return request;
    });
  };

  const handleError = (error) => {
    const message =
      error.response?.data?.message ||
      error.response?.data?.[0]?.message ||
      error.message ||
      'Unknown error';

    return Promise.reject(message);
  };

  [...instancesWithXAuth, ...instancesWithoutXAuth].forEach(instance => {
    instance?.interceptors.response.use(
      response => response,
      handleError
    );
  });

  instancesWithXAuth.forEach(instance => setHeaders(instance, true));
  instancesWithoutXAuth.forEach(instance => setHeaders(instance, false));

  const kc = getKeycloak();
  if (kc) {
    startKeycloakAutoRefresh(kc, 30);

    if (typeof kc.logout === 'function') {
      const originalLogout = kc.logout.bind(kc);
      kc.logout = (...args) => {
        stopKeycloakAutoRefresh();
        return originalLogout(...args);
      };
    }


  }
}


export {
  initialize,
  clannAxios,
  savatarAxios,
  checkAvailability,
  picksAxios,
  startKeycloakAutoRefresh,
  stopKeycloakAutoRefresh,
};
